export const SET_CALDERAS_DATA = 'SET_CALDERAS_DATA'
export const CALDERAS_LOAD = 'CALDERAS_LOAD'
export const CALDERAS_FAILURE = 'CALDERAS_FAILURE'
export const SET_PROVINCIAS_DATA = 'SET_PROVINCIAS_DATA'
export const PROVINCIAS_LOAD = 'PROVINCIAS_LOAD'
export const PROVINCIAS_FAILURE = 'PROVINCIAS_FAILURE'
export const SET_MUNICIPIOS_DATA = 'SET_MUNICIPIOS_DATA'
export const MUNICIPIOS_LOAD = 'MUNICIPIOS_LOAD'
export const MUNICIPIOS_FAILURE = 'MUNICIPIOS_FAILURE'
